import _taggedTemplateLiteral from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
/** @format */

import gql from 'graphql-tag';
var edrCampaignBannerQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query {\n    edrCampaignBanner {\n      title\n      hero\n      heroMobile\n      redirectUrl\n    }\n  }\n"])));
export default edrCampaignBannerQuery;